import { useEffect, useState } from 'react';

const useCountryCode = () => {
  const [countryCode, setCountryCode] = useState('us');
  useEffect(() => {
    fetch('https://retrieve.whatsform.com/')
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          const code = response.country ? response.country : 'us';
          setCountryCode(code.toLowerCase());
        }
      })
      .catch((e) => {});
  }, []);
  return countryCode;
};

export default useCountryCode;
